export const LmcContractViolationEnum = {
  MISSED_APPOINTMENT: {
    value: "MISSED_APPOINTMENT",
    displayName: "Missed Appointment Re-referral",
    description: "The patient did not attend, cancelled, or self-discharged, and the hospital asks the GP for a new referral, or tells the patient to return to the GP for re-referral, instead of reinstating or re-booking them directly."
  },
  INAPPROPRIATE_PRESCRIBING: {
    value: "INAPPROPRIATE_PRESCRIBING",
    displayName: "Inappropriate Prescribing",
    description: "The specialist asks the GP to prescribe a hospital-only or specialist-monitored drug, to take over shared care this practice has not accepted, to supply a medicine the hospital has just started or that is needed immediately, or to continue a discharge supply of less than 14 days."
  },
  CHASING_HOSPITAL: {
    value: "CHASING_HOSPITAL",
    displayName: "Chasing Hospital Investigations",
    description: "The hospital, including the Emergency Department, requested a test and then asks the GP to chase the result, sends the result without reviewing it, or tells the patient to contact the GP to obtain or have it explained."
  },
  POST_OP_CHECK: {
    value: "POST_OP_CHECK",
    displayName: "Post-Operative Checks",
    description: "The hospital requests the GP to perform a specific post-surgical review that should be done by the surgical team."
  },
  HOSPITAL_FIT_NOTE: {
    value: "HOSPITAL_FIT_NOTE",
    displayName: "Hospital Fit Notes",
    description: "The patient is told to see the GP for a fit note arising from hospital treatment, surgery, an admission, an Emergency Department attendance, or a condition the hospital is managing, or to extend a fit note the hospital already issued for the same episode."
  },
  SICK_NOTE: {
    value: "SICK_NOTE",
    displayName: "Short-Term Sick Notes",
    description: "A request for a sick note for an absence of less than 7 days (which is covered by self-certification)."
  },
  NON_CONTRACT_ADMIN: {
    value: "NON_CONTRACT_ADMIN",
    displayName: "Non-Contractual Admin",
    description: "Requests for the GP to fill out non-medical questionnaires or perform administrative data gathering not covered by the GMS contract."
  },
  ONWARD_REFERRAL: {
    value: "ONWARD_REFERRAL",
    displayName: "Onward Referral",
    description: "The hospital asks the GP to refer onward, or tells the patient to see the GP for a referral, for the same clinical problem, a finding from the hospital's own assessment, an urgent or potentially cancer-related issue, or another specialty needed to progress the same episode of care."
  },
  HOSPITAL_INVESTIGATION_REQUEST: {
    value: "HOSPITAL_INVESTIGATION_REQUEST",
    displayName: "Hospital Investigation Request",
    description: "The hospital asks the GP to arrange a test it needs for diagnosis, a treatment decision, pre-operative assessment, the next clinic appointment, specialist monitoring, or surveillance, including asking the GP to generate the request form."
  },
  REFERRAL_REJECTION: {
    value: "REFERRAL_REJECTION",
    displayName: "Referral Rejection",
    description: "A GP referral is declined or returned without a clear clinical reason or named alternative pathway, solely because Advice and Guidance was not sought first, or because the patient does not fit a pathway the hospital could have redirected."
  },
  HOSPITAL_FOLLOW_UP: {
    value: "HOSPITAL_FOLLOW_UP",
    displayName: "Hospital Follow-Up",
    description: "Hospital follow-up, booking, or recall is pushed to the GP: the patient is told to contact the GP if an appointment has not arrived, the GP is asked to chase a hospital waiting list, or the GP is asked to re-refer for a planned hospital review."
  }
};

// Helper function to get violation by value
export const getViolationByValue = (value) => {
  return Object.values(LmcContractViolationEnum).find(violation => violation.value === value);
};

// Helper function to get all violation values
export const getAllViolationValues = () => {
  return Object.values(LmcContractViolationEnum).map(violation => violation.value);
};
